var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
var SvgBnb = function SvgBnb(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#clip0_3827_2149)"
  }, /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#clip1_3827_2149)"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0Z",
    fill: "#F0B90B"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "m4.835 10 .008 3.033 2.577 1.516v1.776l-4.085-2.396V9.113l1.5.887Zm0-3.033v1.767l-1.501-.888V6.08l1.5-.888 1.509.888-1.508.888Zm3.661-.888 1.501-.888 1.508.888-1.508.888-1.5-.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M5.918 12.404v-1.776l1.5.888v1.768l-1.5-.88Zm2.577 2.781 1.5.888 1.509-.888v1.767l-1.508.888-1.501-.888v-1.767Zm5.161-9.106 1.501-.888 1.508.888v1.768l-1.508.887V6.967l-1.5-.888Zm1.501 6.954L15.165 10l1.501-.888v4.816l-4.085 2.396v-1.776l2.576-1.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "m14.083 12.404-1.501.88v-1.768l1.5-.888v1.776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "m14.08 7.596.01 1.775-2.585 1.517v3.04l-1.501.88-1.5-.88v-3.04L5.918 9.37V7.596l1.507-.888 2.569 1.524 2.584-1.524 1.508.888h-.006ZM5.919 4.564 9.996 2.16l4.085 2.404-1.5.888-2.585-1.524-2.577 1.524-1.501-.888Z",
    fill: "white"
  })))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "clip0_3827_2149"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "white",
    d: "M0 0h20v20H0z"
  })), /*#__PURE__*/React.createElement(ClipPath, {
    id: "clip1_3827_2149"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "white",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgBnb;